import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11 11h2v2h-2zm0-4h2v2h-2zm10-4H3v18h18V3zm-2 16H5V5h14v14zm-4-8h2v2h-2zm-8 0h2v2H7zm4 4h2v2h-2z"
}), 'BorderOuterTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BorderOuterTwoTone.js
// module id = 2447
// module chunks = 2